import React from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import PageHeading from '../../../../components/admin/common/PageHeading';
import { Link } from 'react-router-dom';

const AssessmentTestStu = () => {
  return (
    <AdminAppBody
      content={
        <div className='container'>
          <PageHeading
            title="Assessments"
            subTitle="Take and review your assessments"
          />

          <div className="mt-4">
            <div className="card shadow-sm">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div>
                  <div className="d-flex align-items-center">
                    <i className="bi bi-check-circle text-danger me-2"></i>
                    <strong>Basics ( Basic)</strong>
                  </div>
                  <div className="text-danger mt-1">Score: 0.00%</div>
                </div>
                <div className="d-flex gap-2">
                  <Link to='/assessments-result'>
                    <button className="btn btn-primary text-white rounded">
                      View Result
                    </button>
                  </Link>
                  <Link to='/assessments-exam'>
                    <button className="btn btn-primary text-white rounded">
                      Retake Test
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AssessmentTestStu;
